import { WebSocketLink } from "@apollo/client/link/ws";
import { createHttpLink, split } from "@apollo/client";

import { getMainDefinition } from "@apollo/client/utilities";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { getUser } from "../utils/tokens";
import { addSeconds } from "date-fns";
import { dedupedRefresh } from "./dedupedRefresh";
import { initReporting } from "../reporting/reporting";
import { environment } from "../environment";

const graphqlUrl = `${environment.VITE_URL_SCHEME}${environment.VITE_SERVER_DOMAIN}/graphql`;
const wsUrl = graphqlUrl.replace("https", "wss").replace("http", "ws");

// datadog has to be initialized before apollo client or we won't get the datadog headers appended to our requests
// see https://github.com/apollographql/apollo-client/issues/7130
initReporting();

export const wsClient = new SubscriptionClient(wsUrl, {
  reconnect: true,
  lazy: true,
  timeout: 45000,
  inactivityTimeout: 1000,
  connectionParams: async () => {
    const accessToken = getUser();
    if (!accessToken || new Date(accessToken.exp * 1000) < addSeconds(new Date(), 15)) {
      const result = await dedupedRefresh();
      if (result) {
        return {
          jwtToken: result.data.accessToken,
        };
      }
    }
    return {};
  },
});

const httpLink = createHttpLink({
  uri: graphqlUrl,
  credentials: "include",

  headers: {
    "x-notemeal-web-schema-version": environment.VITE_WEB_SCHEMA_VERSION,
    client: "web",
  },
});

const wsLink = new WebSocketLink(wsClient);

export const apiLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  httpLink
);
